import { cn } from '@/components/ui';
import type { LicenseStatus } from '@/types/tenant';

const LABEL: Record<LicenseStatus, string> = {
  active: 'Active',
  expiring_soon: 'Expiring soon',
  expired: 'Expired',
  disabled: 'Disabled',
};

const CLASS: Record<LicenseStatus, string> = {
  active: 'border-state-success/40 bg-state-success/10 text-state-success',
  expiring_soon: 'border-state-warning/40 bg-state-warning/10 text-state-warning',
  expired: 'border-state-danger/40 bg-state-danger/10 text-state-danger',
  disabled: 'border-border-default bg-surface-1 text-text-tertiary',
};

export function LicenseStatusBadge({ status }: { status: LicenseStatus | null }) {
  if (!status) {
    return (
      <span className="inline-flex items-center rounded-md border border-border-default bg-surface-1 px-2 py-0.5 text-[10px] font-medium text-text-tertiary">
        No license
      </span>
    );
  }
  return (
    <span className={cn('inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-medium', CLASS[status])}>
      {LABEL[status]}
    </span>
  );
}
